import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { Router } from '@angular/router';
import { CustomerService } from 'src/app/core/services/customer.service';
import { BehaviorSubject, distinctUntilChanged, Observable, Subscription } from 'rxjs';
import { MixpanelService } from 'src/app/core/services/mixpanel.service';
import { Customer, CustomerUser } from 'src/app/core/services/ebr-api-client/ebr-api-client.g';
import { PolicyEvent, PolicyService } from 'src/app/core/services/policy.service';

@Component({
    selector: 'impersonate-option',
    templateUrl: './impersonate-option.component.html',
    styleUrls: ['./impersonate-option.component.css'],
    standalone: false
})
export class ImpersonateOptionComponent implements OnInit {

  customersSubject = new BehaviorSubject<Array<Customer>>([]);
  customers$: Observable<Array<Customer>> = this.customersSubject.asObservable().pipe(
    distinctUntilChanged()
  );

  usersSubject = new BehaviorSubject<Array<CustomerUser>>([]);
  users$: Observable<Array<CustomerUser>> = this.usersSubject.asObservable().pipe(
    distinctUntilChanged()
  );

  customer: Customer | null = null;
  user: CustomerUser | null = null;

  constructor(
    private authenticationService: AuthenticationService,
    private customerService: CustomerService,
    private router: Router,
    private mixpanelService: MixpanelService,
    private policyService: PolicyService
  ) { }

  ngOnInit(): void {

    this.customerService.getCustomers()
    .then((customers) => {
      this.customersSubject.next(customers);
    });
  }

  get isImpersonating() {
    return this.authenticationService.isImpersonating;
  }

  get customers(): Array<Customer> {
    return this.customersSubject.getValue();
  }

  get users(): Array<CustomerUser> {
    return this.usersSubject.getValue();
  }

  onCustomerSelected(customer: Customer) {
    this.customer = customer;
    this.customerService.getUsers(this.customer.name ?? "")
    .then((users) => {
      this.usersSubject.next(users);
    });

  }

  onImpersonate(user: CustomerUser) {
    this.setBodyClassForImpersonation(true);
    localStorage.setItem('UserName',user.firstName +" "+ user.lastName);
    this.authenticationService.startImpersonation(user.email ?? "");
    this.mixpanelService.track('PH login from impersonation', {
      ImpersonatedCustomer: this.customer?.name??" ",
      ImpersonatedUser: `${this.user?.firstName ?? ""} ${this.user?.lastName ?? ""}`,
    });
    this.router.navigate(['/customer-overview'])
  }

  stopImpersonation() {
    this.setBodyClassForImpersonation(false);
    this.authenticationService.stopImpersonation();
    // Navigate only after the policy has refreshed so the guard sees the CAM's
    // updated permissions (not the stale impersonated user's policy).
    const onPolicyLoaded = () => {
      this.policyService.events.unsubscribe(PolicyEvent.PolicyLoaded, onPolicyLoaded);
      this.router.navigate(['/filter']);
    };
    this.policyService.events.subscribe(PolicyEvent.PolicyLoaded, onPolicyLoaded);
  }

  /**
   * Toggles the extra spacing reserved for Neptune header if in impersonation mode
   */
  setBodyClassForImpersonation(isImpersonating: boolean) {
    if(isImpersonating) {
      document.body.classList.add('neptune-ui-enabled-customer');
      document.body.classList.remove('neptune-ui-enabled');
    }
    else {
      document.body.classList.remove('neptune-ui-enabled-customer');
      document.body.classList.add('neptune-ui-enabled');
    }
  }
}
